import styled from 'styled-components';
import { colors, dimensions } from '../../styles';

const buttonSize = 28;

const PaginationWrapper = styled.div`
  background: #fff;
  display: flex;
  align-items: end;
  justify-content: end;
  border-top: 1px solid ${colors.borderPrimary};
  margin-top: -1px;
  position: relative;
  border-radius: 0px 0px 20px 20px;
`;

const PaginationList = styled.ul`
  display: inline-block;
  padding-left: 0;
  margin: 0;
  list-style: none;
  padding: 11px ${dimensions.coreSpacing}px;

  > li {
    display: inline;
    display: inline-flex;
    margin-right: 3px;

    > a,
    > span {
      position: relative;
      float: left;
      min-width: ${buttonSize}px;
      height: ${buttonSize}px;
      // padding: 0 ${dimensions.unitSpacing}px;
      border-radius: ${buttonSize / 2}px;
      line-height: 30px;
      color: #303030;
      text-align: center;
      text-decoration: none;
      outline: 0;
      transition: all ease 0.3s;
      font-weight: 500;

      i {
        margin: 0;
      }

      // &:hover {
      //   background: ${colors.borderPrimary};
      // }

      img {
        width: 8px; 
      }
    }

    &.disabled > a,
    &.disabled > span {
      color: ${colors.colorLightGray};
      cursor: not-allowed;
    }

    &.active > a {
      z-index: 3;
      color: ${colors.colorWhite};
      background-color: ${colors.themeBlue};
    }
  }

  span {
    font-weight: 600;
  }
`;

const PerPageButton = styled.a`
  font-weight: 600;
  color: #303030;
  cursor: pointer;
  margin-left: 12px;
  position: relative;
  // top: -2px;

  i {
    margin-left: 3px;
    font-size: 10px;
  }

  i::before {
    font-weight: 600;
  }
`;

const Option = styled.li`
  a {
    cursor: pointer;
  }
`;

export { PaginationWrapper, PaginationList, PerPageButton, Option };



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/reportPagination/styles.js